export function isReducedMotionEnabled() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches === true;
}